import { IAccreditationApplication } from '../../../interfaces/IAccreditationApplication';
import { Col, Row } from 'react-bootstrap';
import React from 'react';
import ApplicationBlock from '../ApplicationBlock/ApplicationBlock';
import IApplicationReview from '../../../interfaces/IApplicationReview';
import { ApplicationAction } from './ApplicationsBlock';
import { sortBy } from 'lodash';

interface Props {
    applications: IAccreditationApplication[];
    header: string;
    onSelectApplication: (app: IAccreditationApplication, action: ApplicationAction) => void;
    onSelectReview: (rev: IApplicationReview, app: IAccreditationApplication) => void;
    onAbandonApplication: (app: IAccreditationApplication) => void;
    onSubmitFinalApplication: (app: IAccreditationApplication) => void;
    onSubmitForReview: (app: IAccreditationApplication) => void;
    updating: boolean;
}

const ApplicationsBlockList: React.FC<Props> = ({
    applications,
    header,
    onSelectApplication,
    onSelectReview,
    onAbandonApplication,
    onSubmitFinalApplication,
    onSubmitForReview,
    updating,
}) => {
    const sortedApplications = sortBy(applications, 'updatedDate', 'accreditationType.name');
    return (
        <>
            <h2 className={'fs-2 mb-4'}>{header}</h2>
            {sortedApplications.map((application, index) => (
                <Row
                    key={`application-${index}`}
                    className={index === applications.length - 1 ? 'mb-4' : ''}
                >
                    <Col>
                        <ApplicationBlock
                            application={application}
                            accreditationType={application.accreditationType}
                            handleOnSelectReview={(review) => onSelectReview(review, application)}
                            handleOnSelectApplication={() =>
                                onSelectApplication(application, 'apply')
                            }
                            handleOnViewApplication={() => onSelectApplication(application, 'view')}
                            handleOnAbandonApplication={() => onAbandonApplication(application)}
                            handleOnSubmitForReview={() => onSubmitForReview(application)}
                            handleOnSubmitApplication={() => onSubmitFinalApplication(application)}
                            updating={updating}
                        />
                    </Col>
                </Row>
            ))}
        </>
    );
};

export default ApplicationsBlockList;
